/* ROHPPER — capa de movimiento (ver rohpper-motion.css). Sin dependencias. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  var root = document.documentElement;
  root.classList.add('rohpper-motion');

  /* 1) Entrada escalonada de tarjetas al entrar en pantalla */
  var cards = Array.prototype.slice.call(document.querySelectorAll('.rohpper-card'));
  function showCard(c) { c.classList.add('rohpper-card--in'); }
  if ('IntersectionObserver' in window && cards.length) {
    var seen = 0;
    var io = new IntersectionObserver(function (entries) {
      var batch = entries.filter(function (e) { return e.isIntersecting; });
      batch.forEach(function (e, i) {
        e.target.style.setProperty('--rc-i', String(i));
        showCard(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    cards.forEach(function (c) { io.observe(c); });
  } else {
    cards.forEach(showCard);
  }
  /* Red de seguridad: nada se queda oculto */
  setTimeout(function () { cards.forEach(showCard); }, 4000);

  /* 2) Foco de luz que sigue al cursor (solo ratón) */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('pointermove', function (e) {
      var media = e.target && e.target.closest ? e.target.closest('.rohpper-card__media') : null;
      if (!media) return;
      var r = media.getBoundingClientRect();
      media.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      media.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  /* 3) Transición compartida: la foto de la tarjeta "viaja" a la ficha.
        Usa el mecanismo del tema (view-transitions.js + base.css). */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
    var link = e.target && e.target.closest ? e.target.closest('.rohpper-card a[href*="/products/"]') : null;
    if (!link) return;
    var card = link.closest('.rohpper-card');
    var media = card && card.querySelector('.rohpper-card__media');
    if (!media) return;
    document.querySelectorAll('[data-view-transition-triggered]').forEach(function (n) {
      n.removeAttribute('data-view-transition-triggered');
    });
    media.setAttribute('data-view-transition-type', 'product-image-transition');
    media.setAttribute('data-view-transition-triggered', 'true');
  }, true);
})();
